// ====================================================================================
// header.module
// ====================================================================================

const header = {
  el: document.querySelector(".header"),
  isMini: false,
  scrollStart: document.querySelector(".banner") ? 99 : 7,
};

const updateHeaderHeight = () => {
  let headerHeight = header.el.offsetHeight;
  document.querySelector("main").style.marginTop = headerHeight + "px";
};

const scrollHandler = () => {
  let sc = window.scrollY || window.pageYOffset;
  if (sc > header.scrollStart) {
    if (header.isMini) return;
    header.el.classList.add("header--mini");
    header.isMini = true;
  } else {
    if (header.el.classList.contains("header--mini")) {
      header.el.classList.remove("header--mini");
      header.isMini = false;
    }
  }
};

export const init = () => {
  let attempts = 0;

  updateHeaderHeight();

  if ((window.scrollY || window.pageYOffset) > 159) {
    header.el.classList.add("header--mini");
  }

  // if document.ready needed
  const whenComplete = () => {
    if (attempts > 30) return;
    attempts += 1;
    if (document.readyState === "complete") {
      window.addEventListener("scroll", scrollHandler);

      let intervalId = setInterval(() => {
        updateHeaderHeight();
      }, 50);

      window.onbeforeunload = function () {
        clearInterval(intervalId);
      };
    } else {
      setTimeout(function () {
        whenComplete();
      }, 400);
    }
  };
  whenComplete();
};
